import GroupRuleEditDialog from "./groupRuleEditDialog.container";

export default GroupRuleEditDialog;
